import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import cx from 'classnames';
import { Popover, Button } from 'antd';
import {
  CaretDownOutlined,
} from '@ant-design/icons';

export class EditorElementPopover extends React.Component {
  state = {
    visible: false,
  };

  static propTypes = {
    showBtn: PropTypes.bool,
    publish: PropTypes.bool,
    title: PropTypes.string,
    btnLabel: PropTypes.string,
    content: PropTypes.object,
    placement: PropTypes.string,
    usecase: PropTypes.string.isRequired,
  };

  static defaultProps = {
    showBtn: false,
    publish: false,
    title: '',
    btnLabel: 'edit',
    content: null,
    placement: 'bottomLeft',
  }

  dismiss = () => {
    this.setState({ visible: false });
  };

  propagateEventsYes = () => {};
  // propagateEventsNo = (e) => { e.stopPropagation(); };

  render() {
    const {
      showBtn,
      publish,
      title, content, btnLabel,
      placement,
      usecase,
    } = this.props;

    const contentWrapper = (
      <div
        className={cx('p__popover', `p${usecase}__popover`)}
        onMouseOver={this.propagateEventsYes}
        onFocus={this.propagateEventsYes}
        onMouseOut={this.propagateEventsYes}
        onBlur={this.propagateEventsYes}
      >
        {content}
      </div>
    );

    return publish === true ? null : (
      <CSSTransition
        in={showBtn}
        classNames="edit__btn"
        className="edit__btn"
        timeout={300}
      >
        <span>
          <Popover
            overlayClassName="editor__popover__wrap"
            content={contentWrapper}
            title={title}
            placement={placement}
            visible={this.state.visible}
            trigger="click"
            onVisibleChange={v => this.setState({ visible: v })}
          >
            <span>
              <Button type="primary" size="small">
                {btnLabel}
                <CaretDownOutlined />
              </Button>
            </span>
          </Popover>
        </span>
      </CSSTransition>
    );
  }
}
// visible={this.state.visible}



// WEBPACK FOOTER //
// ./scripts/components/editor/EditorElementPopover.jsx